import { StyledRange } from "@silevis/reactgrid";
import dayjs from "dayjs";
import moment from "moment";
import {
  ApplicationContextType,
  loanType,
} from "../../../../interfaces/interfaces";

// don't change the column names, as they are used for key based index from the data
// so if we need to change the column names, we need to change the data as well, therefore change the enum ColumnTitle which is below this enum definition

export enum debtScheduleColumns {
  lenderName = "lenderName",
  loanType = "loanType",
  totalLoanAmount = "totalLoanAmount",
  fintechPlatform = "escrowHeld",
  // marketplace = "Escrow Held",
  remainingPrincipal = "outstandingAmount",
  // annualInterestRate = "Annual Interest Rate (%)",
  repaymentFrequency = "repaymentFrequency",
  startDate = "startDate",
  endDate = "endDate",
  instalmentAmount = "instalmentAmount",
  isReceived = "isReceived",
}

export enum debtScheduleColumnTitle {
  lenderName = "Lender Name",
  loanType = "Loan Type",
  totalLoanAmount = "Total Loan Amount",
  fintechPlatform = "Escrow Held",
  // marketplace = "Marketplace",
  remainingPrincipal = "Outstanding Amount (₹)",
  // annualInterestRate = "Annual Interest Rate (%)",
  repaymentFrequency = "Repayment Frequency",
  startDate = "Start Date",
  endDate = "End Date",
  instalmentAmount = "Instalment Amount (₹)",
}

export const debtScheduleHeaders = [
  debtScheduleColumns.lenderName,
  debtScheduleColumns.loanType,
  debtScheduleColumns.totalLoanAmount,
  debtScheduleColumns.remainingPrincipal,
  // debtScheduleColumns.fintechPlatform,
  debtScheduleColumns.fintechPlatform,
  // debtScheduleColumns.annualInterestRate,
  debtScheduleColumns.repaymentFrequency,
  debtScheduleColumns.startDate,
  debtScheduleColumns.endDate,
  debtScheduleColumns.instalmentAmount,
];

export const debtScheduleHeadersObj = {
  [debtScheduleColumns.lenderName]: {
    title: debtScheduleColumnTitle.lenderName,
    styles: {
      justifyContent: "flex-start",
    },
    type: "string",
    isTotal: false,
    isMandatory: true,
  },
  [debtScheduleColumns.loanType]: {
    title: debtScheduleColumnTitle.loanType,
    styles: {
      justifyContent: "flex-start",
    },
    type: "select",
    isTotal: false,
    width: 180,
    options: [
      {
        label: "Term Loan",
        value: loanType.termLoan,
      },
      {
        label: "WCDL",
        value: loanType.wcdl,
      },
      {
        label: "CC",
        value: loanType.cc,
      },
      {
        label: "Others",
        value: loanType.others,
      },
    ],
    optionLabelKey: "label",
    isMandatory: true,
  },
  [debtScheduleColumns.totalLoanAmount]: {
    title: debtScheduleColumnTitle.totalLoanAmount,
    styles: {
      justifyContent: "flex-end",
    },
    type: "number",
    format: new Intl.NumberFormat("en-IN", {
      maximumFractionDigits: 2,
      minimumFractionDigits: 0,
    }),
    isTotal: true,
  },
  [debtScheduleColumns.fintechPlatform]: {
    title: debtScheduleColumnTitle.fintechPlatform,
    styles: {
      justifyContent: "flex-start",
    },
    type: "string",
    isTotal: false,
    isMandatory: true,
  },
  // [debtScheduleColumns.marketplace]: {
  //   title: debtScheduleColumns.marketplace,
  //   styles: {
  //     justifyContent: "flex-start",
  //   },
  //   type: "string",
  //   isTotal: false,
  // },
  [debtScheduleColumns.remainingPrincipal]: {
    title: debtScheduleColumnTitle.remainingPrincipal,
    styles: {
      justifyContent: "flex-end",
    },
    type: "number",
    format: new Intl.NumberFormat("en-IN", {
      maximumFractionDigits: 2,
      minimumFractionDigits: 0,
    }),
    hideZero: false,
    isTotal: true,
    isMandatory: true,
  },
  // [debtScheduleColumns.annualInterestRate]: {
  //   title: debtScheduleColumns.annualInterestRate,
  //   styles: {
  //     justifyContent: "flex-end",
  //   },
  //   type: "number",
  //   isTotal: false,
  // },
  [debtScheduleColumns.repaymentFrequency]: {
    title: debtScheduleColumnTitle.repaymentFrequency,
    styles: {
      justifyContent: "flex-start",
    },
    type: "string",
    isTotal: false,
    isMandatory: false,
  },
  [debtScheduleColumns.startDate]: {
    title: debtScheduleColumnTitle.startDate,
    styles: {
      justifyContent: "center",
    },
    type: "date",
    isTotal: false,
    isMandatory: false,
  },
  [debtScheduleColumns.endDate]: {
    title: debtScheduleColumnTitle.endDate,
    styles: {
      justifyContent: "center",
    },
    type: "date",
    isTotal: false,
    isMandatory: false,
  },
  [debtScheduleColumns.instalmentAmount]: {
    title: debtScheduleColumnTitle.instalmentAmount,
    styles: {
      justifyContent: "flex-end",
    },
    type: "number",
    format: new Intl.NumberFormat("en-IN", {
      maximumFractionDigits: 2,
      minimumFractionDigits: 0,
    }),
    isTotal: true,
    isMandatory: false,
  },
};

const rowStyles = [];

export const getInitialDebtSchedule = (): {
  headers: any[];
  rowData: any[];
  footer: any;
} => {
  const rowData = [];
  const initialRow = {};
  debtScheduleHeaders.forEach((header) => {
    initialRow[header] = "";
  });
  rowData.push(initialRow);

  const initialFooter = {};
  debtScheduleHeaders.forEach((header, index) => {
    initialFooter[header] = index === 0 ? "Total" : "-";
  });

  const headers = [];
  debtScheduleHeaders.forEach((header) => {
    headers.push({
      key: header,
      value: debtScheduleHeadersObj[header].title,
    });
  });
  // const rowData = [Array(debtScheduleHeaders.length).fill("")];
  // const footer = ["Total", ...Array(debtScheduleHeaders.length - 1).fill("-")];

  return {
    headers: headers,
    rowData: rowData,
    footer: initialFooter,
  };
};

export const onAddInitialDebtScheduleRow = () => {
  const initialRow = {};
  debtScheduleHeaders.forEach((header) => {
    initialRow[header] = "";
  });
  return initialRow;
};

export const getDebtScheduleGridInvalidRange = (gridData: any) => {
  // let hasData = false;
  let missingDataErrors: StyledRange[] = [];
  let dateErrors: StyledRange[] = [];

  // Optional fields that can be skipped in validation
  const optionalFields = [
    debtScheduleColumns.startDate,
    debtScheduleColumns.endDate,
    debtScheduleColumns.instalmentAmount,
    debtScheduleColumns.repaymentFrequency,
  ];

  gridData.rowData.forEach((row, rowIndex) => {
    // **Check if the row has any data**
    // if () hasData = true;
    console.log("row", row);
    const hasData =
      gridData.rowData?.length == 1
        ? true
        : debtScheduleHeaders.some((headerKey) => {
            const cell = row[headerKey];

            // treat null/undefined/NaN as "empty"
            if (
              cell == null ||
              (typeof cell === "number" && Number.isNaN(cell))
            ) {
              return false;
            }

            // otherwise stringify+trim and check for non-empty
            return cell.toString().trim() !== "";

            // row[headerKey]?.toString().trim() !== ""
          });
    console.log("hasData", hasData);
    if (!hasData) return;

    // Check if start date or end date is provided for conditional validation
    const hasStartDate =
      row[debtScheduleColumns.startDate]?.toString().trim() !== "";
    const hasEndDate =
      row[debtScheduleColumns.endDate]?.toString().trim() !== "";

    debtScheduleHeaders.forEach((headerKey, colIndex) => {
      const cell = row[headerKey] || "";

      // const columnKey = gridData.headers[colIndex];
      const columnType = debtScheduleHeadersObj[headerKey]?.type;

      // **Step 1: Check for Empty Cells in Non-Empty Rows**
      // Skip optional fields unless they have conditional requirements
      const isOptionalField = optionalFields.includes(headerKey);

      // allowing zero values for remaining principal
      if (
        headerKey === debtScheduleColumns.remainingPrincipal &&
        Number(cell) == 0
      ) {
        console.log("allowing zero value for remaining principal", cell);
        return;
      }

      // If start date is provided, end date is required and vice versa
      const isRequiredByCondition =
        (headerKey === debtScheduleColumns.startDate && hasEndDate) ||
        (headerKey === debtScheduleColumns.endDate && hasStartDate);

      if (hasData && cell?.toString().trim() === "") {
        // Only add error if field is not optional OR it's required by condition
        if (!isOptionalField || isRequiredByCondition) {
          missingDataErrors.push({
            range: {
              start: { rowIndex: rowIndex + 1, columnIndex: colIndex },
              end: { rowIndex: rowIndex + 2, columnIndex: colIndex + 1 },
            },
            styles: { background: "#FDF1F1" }, // Light red for missing data
          });
        }
      }

      // **Step 2: Check for Date Validations (End Date before Start Date)**
      // Only validate dates if both start and end dates are provided
      if (
        !missingDataErrors.length &&
        columnType === "date" &&
        hasStartDate &&
        hasEndDate
      ) {
        const isEndDateCol = headerKey == debtScheduleColumns.endDate;
        const startDateIndex = debtScheduleColumns.startDate;

        if (isEndDateCol) {
          const startDate = moment(row[startDateIndex], "DD/MM/YYYY");
          const endDate = moment(cell, "DD/MM/YYYY");

          if (
            !startDate.isValid() ||
            !endDate.isValid() ||
            endDate.isBefore(startDate)
          ) {
            dateErrors.push({
              range: {
                start: { rowIndex: rowIndex + 1, columnIndex: colIndex },
                end: { rowIndex: rowIndex + 2, columnIndex: colIndex + 1 },
              },
              styles: { background: "#FDF1F1" }, // Yellow for invalid dates
            });
          }
        }
      }
    });
  });

  return { missingDataErrors, dateErrors };
};

export const findFirstDebtScheduleGridError = (
  gridData: any,
  checkEmpty = true
) => {
  if (!gridData) {
    if (checkEmpty) {
      return {
        type: "missingData",
        message: "At least one value is required.",
        range: {
          start: { rowIndex: 1, columnIndex: 0 },
          end: { rowIndex: 2, columnIndex: 1 },
        },
        styles: { background: "#FDF1F1" }, // Light red
      };
    } else {
      return "";
    }
  }

  // Optional fields that can be skipped in validation
  const optionalFields = [
    debtScheduleColumns.startDate,
    debtScheduleColumns.endDate,
    debtScheduleColumns.instalmentAmount,
    debtScheduleColumns.repaymentFrequency,
  ];

  const totalRows = gridData.rowData.length;

  for (let rowIndex = 0; rowIndex < totalRows; rowIndex++) {
    const row = gridData.rowData[rowIndex];

    // **Check if the row has any data**
    const hasData = debtScheduleHeaders.some(
      (headerKey) => row[headerKey]?.toString().trim() !== ""
    );

    // **Step 1: If only one row and empty, show missing data error**
    if (totalRows === 1 && !hasData && checkEmpty) {
      return {
        type: "missingData",
        message: "At least one value is required.",
        range: {
          start: { rowIndex: 1, columnIndex: 0 },
          end: { rowIndex: 2, columnIndex: gridData.headers.length },
        },
        styles: { background: "#FDF1F1" }, // Light red
      };
    }

    // **Step 2: If multiple rows, check each row with at least one value**
    console.log("totalRows", totalRows, "hasData", hasData);
    if (hasData) {
      // Check if start date or end date is provided for conditional validation
      const hasStartDate =
        row[debtScheduleColumns.startDate]?.toString().trim() !== "";
      const hasEndDate =
        row[debtScheduleColumns.endDate]?.toString().trim() !== "";

      for (
        let colIndex = 0;
        colIndex < debtScheduleHeaders.length;
        colIndex++
      ) {
        const headerKey = debtScheduleHeaders[colIndex];
        const cell = row[headerKey];
        // const columnKey = gridData.headers[colIndex];
        const columnType = debtScheduleHeadersObj[headerKey]?.type;

        // **Step 2.1: If a row has data, check for missing values**
        // Skip optional fields unless they have conditional requirements
        const isOptionalField = optionalFields.includes(headerKey);

        // If start date is provided, end date is required and vice versa
        const isRequiredByCondition =
          (headerKey === debtScheduleColumns.startDate && hasEndDate) ||
          (headerKey === debtScheduleColumns.endDate && hasStartDate);

        // allowing zero values for remaining principal
        if (
          headerKey === debtScheduleColumns.remainingPrincipal &&
          Number(cell) == 0
        ) {
          console.log("allowing zero value for remaining principal", cell);
          return;
        }

        if (cell?.toString().trim() === "" || !cell) {
          // Only add error if field is not optional OR it's required by condition
          if (!isOptionalField || isRequiredByCondition) {
            return {
              type: "missingData",
              message: "Some cells are missing data.",
              range: {
                start: { rowIndex: rowIndex + 1, columnIndex: colIndex },
                end: { rowIndex: rowIndex + 2, columnIndex: colIndex + 1 },
              },
              styles: { background: "#FDF1F1" }, // Light red
            };
          }
        }

        // **Step 3: If no missing values, check for date validation**
        // Only validate dates if both start and end dates are provided
        if (columnType === "date" && hasStartDate && hasEndDate) {
          console.log("columnType", columnType);
          const isEndDateCol = headerKey == debtScheduleColumns.endDate;
          const startDateIndex = debtScheduleColumns.startDate;

          if (isEndDateCol) {
            const startDate = moment(row[startDateIndex], "DD/MM/YYYY");
            const endDate = moment(cell, "DD/MM/YYYY");
            console.log("checking for invalid date");
            if (
              !startDate.isValid() ||
              !endDate.isValid() ||
              endDate.isBefore(startDate)
            ) {
              return {
                type: "invalidDate",
                message: "End date cannot be before start date.",
                range: {
                  start: { rowIndex: rowIndex + 1, columnIndex: colIndex },
                  end: { rowIndex: rowIndex + 2, columnIndex: colIndex + 1 },
                },
                styles: { background: "#FFD700" }, // Yellow for invalid dates
              };
            }
          }
        }
      }
    }
  }

  return null; // ✅ No errors found
};
